module.exports = __webpack_public_path__ + "static/media/CHANGELOG.511062a2.md";